export default __webpack_public_path__ + "static/media/slack.dbd60006.svg";